import React from "react";

interface TeamMemberProps {
    name: string;
    role: string;
    imageUrl: string;
}

const TeamMember: React.FC<TeamMemberProps> = ({ name, role, imageUrl }) => (
    <div className="flex flex-col items-center">
        <div className="w-36 h-36 sm:w-[220px] sm:h-[220px] md:w-[260px] md:h-[260px] rounded-full mb-4 overflow-hidden">
            <img 
                src={imageUrl} 
                alt={name} 
                className="w-full h-full object-cover"
                id="team-img"
            />
        </div>
        <div className="text-center">
            <h3 id="team-name" className="font-semibold md:text-lg text-sm">{name}</h3>
            <p id="team-role" className="md:text-md text-xs font-medium">{role}</p>
        </div>
    </div>
);

const TheTeam: React.FC = () => {
    const teamMembers: TeamMemberProps[] = [
        { name: "Vijay Kuppa", role: "CEO", imageUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/Vijay.webp` },
        { name: "Varun Shah", role: "Content & Strategy Lead", imageUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/Varun.webp` },
        { name: "Abhishek Verma", role: "Sr. Staff Software Engineer", imageUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/Abhishek.webp` },
        { name: "Priyansh Saxena", role: "Head of Customer Experience", imageUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/Priyansh.webp` },
        { name: "Yash Shah", role: "Product Manager", imageUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/Yash.webp` },
        { name: "Ashish Oswal", role: "Investments Sales Lead", imageUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/Ashish.webp` },
    ];

    return (
        <div className="flex flex-col items-center justify-center align-middle mt[54px]">
            <div className="flex flex-col px-4 sm:px-10 md:px-36 w-full">
                <h2 id="heading" className="md:mb-8 mb-0 text-4xl sm:text-5xl md:text-6xl font-semibold leading-tight text-center">
                    The Team
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-x-[84px] justify-center md:mt-0 mt-4 mb-[54px]">
                    {teamMembers.map((member, index) => (
                        <TeamMember key={index} name={member.name} role={member.role} imageUrl={member.imageUrl} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TheTeam;
